// This file is automatically generated. Do not edit it directly.
import { createMiddleware } from '@tanstack/react-start'

// Must be registered as a global `functionMiddleware` in `src/start.ts`; otherwise
// the browser never attaches the bearer token to serverFn RPCs.
//
// Import Supabase only when a server function actually runs. The landing page
// never calls one, so eagerly importing the client would ship ~100 KiB of
// unused JS (auth + realtime) on every first load.
export const attachSupabaseAuth = createMiddleware({ type: 'function' }).client(
  async ({ next }) => {
    const { supabase } = await import('./client')
    const { data } = await supabase.auth.getSession()
    const token = data.session?.access_token
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
  },
)
